import type { CancelablePromise } from '/src/api';
import { OpenAPI, request as __request } from '/src/api';
import type { ReferralPartner } from '/src/lib/models/ReferralPartner';

export type CreateReferralPartnerRequest = {
  name: string;
};

export class ReferralPartnerService {
  /**
   * List Referral Partners
   * @returns ReferralPartner[]
   * @throws ApiError
   */
  public static list(): CancelablePromise<ReferralPartner[]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/referralPartners',
    });
  }

  /**
   * Create Referral Partner
   * @returns ReferralPartner
   * @throws ApiError
   */
  public static create(data: CreateReferralPartnerRequest): CancelablePromise<ReferralPartner> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/referralPartners',
      body: data,
    });
  }
}
